import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";

export default function QuoteCTA({
  title = "Planning a project?",
  copy = "Bulky freight, trade volumes, custom sizes and made-to-order pieces — send one quote request and our team will handle the rest.",
}) {
  return (
    <section className="bg-kwila px-5 py-20 text-cream md:px-10 md:py-28" data-testid="quote-cta-band">
      <div className="mx-auto flex max-w-[1500px] flex-col items-start justify-between gap-8 md:flex-row md:items-end">
        <Reveal>
          <Kicker dark>Request a Quote</Kicker>
          <h2 className="mt-3 max-w-2xl font-display text-4xl font-light leading-none tracking-tight md:text-6xl">
            {title}
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-cream/75 md:text-base">{copy}</p>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-wrap gap-3">
          <Link
            to="/request-quote"
            data-testid="cta-request-quote-button"
            className="flex items-center gap-2 rounded-full bg-cream px-8 py-3.5 text-xs font-bold uppercase tracking-[0.14em] text-ink transition-colors hover:bg-ink hover:text-cream"
          >
            Request a Quote <ArrowUpRight size={15} />
          </Link>
          <Link
            to="/contact"
            data-testid="cta-contact-button"
            className="flex items-center gap-2 rounded-full border border-cream/40 px-8 py-3.5 text-xs font-bold uppercase tracking-[0.14em] transition-colors hover:bg-cream hover:text-ink"
          >
            Contact Us
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
